import styled from 'styled-components';
import { MDBContainer } from 'mdbreact';

import { Text } from 'components/DescriptionText/styles';
import { Divider as DefaultDivider } from 'components/FormGroup/Divider/styles';
import { Card } from 'components/Cards/ContentFormCard/styles';

import colors from 'themes/Main';

const { gray03, gray05 } = colors;

export const Loader = styled.div`
  z-index: 50;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8);
`;

export const Container = styled(MDBContainer)`
  margin: 0 auto;
  max-width: calc(100% - 224px) !important;
`;

export const Introduction = styled.div`
  margin-top: 50px;
`;

export const FeaturedText = styled(Text)`
  text-transform: uppercase;

  span {
    display: inline-block;
    font-size: 18px;
    color: ${gray03};
    font-weight: 400;
    margin-left: 8px;
  }
`;

export const Divider = styled(DefaultDivider)`
  margin-top: 32px;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 100%;
    height: 1px;
    background-color: ${gray05};
  }
`;

export const Form = styled.form``;

export const FlexRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  > div {
    width: 45%;
  }
`;

export const Buttons = styled.div`
  margin: 32px 0;

  button:nth-child(2) {
    margin-left: 16px;
  }
`;

export const Allocation = styled(Card)`
  &.isOld {
    opacity: 0.5;
    box-shadow: none;
  }
`;
